<template>
	<div class="card mb_0">
		<h3 class="title mb_20">{{ $t('rtr_activity.detail') }}</h3>
		<table class="table_type_a">
			<colgroup>
				<col style="width: 180px" />
			</colgroup>
			<tbody v-if="transferType === 'account'">
				<tr>
					<th>{{ $t('rtr_activity.asset_name') }}</th>
					<td>
						{{ activityInfo.asset_code + ' ' + activityInfo.asset_title }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity.sender') }}</th>
					<td>
						{{ activityInfo.from_user_name }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity.recipient') }}</th>
					<td>
						{{ activityInfo.to_user_name }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity.w_account') }}</th>
					<td>
						{{ activityInfo.from_account_number }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity.d_account') }}</th>
					<td>
						{{ activityInfo.to_account_number }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity.amount') }}</th>
					<td>
						{{ activityInfo.amount }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity.type') }}</th>
					<td
						v-if="
							activityInfo.from_user_name ===
							$store.state.auth.member_info.user_name
						"
						class="send_receive"
					>
						<span class="send">{{ $t('rtr_activity.withdrawal') }}</span>
					</td>
					<td v-else class="send_receive">
						<span class="receive">{{ $t('rtr_activity.deposit') }}</span>
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.detail.th11') }}</th>
					<td>
						{{ $dayjs(activityInfo?.regdate).format('YYYY.MM.DD HH:mm:ss') }}
					</td>
				</tr>
			</tbody>
			<tbody v-else-if="transferType === 'address'">
				<tr>
					<th>{{ $t('rtr_activity.asset_name') }}</th>
					<td>
						{{ activityInfo.asset_code + ' ' + activityInfo.asset_title }}
					</td>
				</tr>
				<tr>
					<th v-if="addressType === 'deposit'">
						{{ $t('rtr_activity.w_account') }}
					</th>
					<th v-else>{{ $t('rtr_activity.d_account') }}</th>
					<td>
						{{ activityInfo.account_number }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity.amount') }}</th>
					<td>
						{{ activityInfo.request_amount }}
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity.type') }}</th>
					<td class="send_receive">
						<span v-if="addressType === 'deposit'" class="receive">{{
							$t('rtr_activity.deposit')
						}}</span>
						<span v-else class="send">{{ $t('rtr_activity.withdrawal') }}</span>
					</td>
				</tr>
				<tr>
					<th>{{ $t('rtr_activity-exchange.detail.th11') }}</th>
					<td>
						{{ $dayjs(activityInfo?.regdate).format('YYYY.MM.DD HH:mm:ss') }}
					</td>
				</tr>
			</tbody>
		</table>
		<div class="button_area tac mt_50">
			<button @click="$emit('back')">{{ $t('button.back') }}</button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ActivityDetail',
	props: {
		activityInfo: {
			type: Object,
		},
		transferType: {
			type: String,
		},
		addressType: {
			type: String,
		},
	},
	created() {
		window.scrollTo(0, 0);
	},
};
</script>

<style scoped></style>
